import firebase from "firebaseConfig"
import * as fire from "firebase"
import randomstring from "randomstring"
import Config from "config"

export const registerAction = (name, email, password) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()

    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((user) => {
        var userProfile = firebase.auth().currentUser
        dispatch({ type: "login", payload: true })
        if (user) {
          userProfile
            .updateProfile({
              displayName: name,
            })
            .then((s) => {
              console.log("Success")
              userProfile
                .sendEmailVerification()
                .then(function () {
                  // Email sent.
                  console.log("Verification Email Sent")
                })
                .catch(function (err) {
                  // An error happened.
                  console.log(`Verification Email Not Sent. Error:\n${err}`)
                })
              return firestore
                .collection("customers")
                .doc(userProfile.uid)
                .set({
                  name,
                  email,
                  time: fire.firestore.FieldValue.serverTimestamp(),
                })
                .then(() => {
                  dispatch({ type: "register", payload: true })
                  console.log("Customer Successfully Created.")
                  // return window.location.replace('/');
                })
                .catch((err) => {
                  console.log(`Error Creating Customer. Error:\n${err}`)
                  // return window.location.replace('/');
                })
            })
        }
      })
      .catch((err) => {
        dispatch({ type: "register_failed", payload: "failed", err })
      })
  }
}

export const orgRegisterAction = (name, email, password) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()

    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((user) => {
        const userProfile = firebase.auth().currentUser

        const fetchOptions = {
          method: "POST",
          body: JSON.stringify({
            email,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }

        if (user) {
          return fetch(
            Config.FirebaseFunctionUrl + "/app/addMerchantRole",
            fetchOptions
          )
            .then((res) => res.json())
            .then((data) => {
              console.log(data)
              userProfile
                .updateProfile({
                  displayName: name,
                })
                .then(() => {
                  console.log("User Profile Updated.")
                  userProfile
                    .sendEmailVerification()
                    .then(function () {
                      // Email sent.
                      console.log("Verification Email Sent")
                    })
                    .catch(function (err) {
                      // An error happened.
                      console.log(`Verification Email Not Sent. Error:\n${err}`)
                    })
                  return addMerchantToFirestore(
                    firestore,
                    dispatch,
                    userProfile.uid,
                    name,
                    email
                  )
                })
                .catch((err) => console.log(err))
            })
            .catch((err) => console.log(err))
        }
      })
      .catch((err) => {
        dispatch({ type: "register_merchant_failed", payload: "failed", err })
      })
  }
}

function addMerchantToFirestore(firestore, dispatch, uid, name, email) {
  const id = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\s\s+/g, " ") // Replace Multiple Spaces With A Single Space
    .trim()
    .split(" ")
    .join("-")
  const unique = randomstring.generate({
    length: 8,
    readable: true,
    capitalization: "lowercase",
  })
  return firestore
    .collection("merchants")
    .doc(uid)
    .set({
      status: "enabled",
      verified: false,
      name,
      email,
      merchantId: id + "-" + unique,
      time: fire.firestore.FieldValue.serverTimestamp(),
    })
    .then(() => {
      console.log("Merchant Created In Firestore.")
      dispatch({ type: "register", payload: true })
      // return firebase.auth().signOut()
      //   .then(() => {
      //     console.log('User Logged Out.');
      //     window.location.replace('/a/login');
      //   })
      //   .catch(err => console.log(err))
      return refreshFirebaseAuthIdToken()
    })
    .catch((err) => console.log(err))
}

function refreshFirebaseAuthIdToken() {
  return firebase
    .auth()
    .currentUser.getIdToken(true)
    .then(() => {
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // console.log(idTokenResult);
          if (idTokenResult.claims.role_merchant) {
            // return window.location.replace('/m/profile');
          }
          // return window.location.replace('/');
        })
        .catch((err) => console.log(err))
    })
    .catch((err) => console.log(err))
}
